import React from "react";
import { inject, observer } from "mobx-react";
import { Separator } from "component/atoms/contextmenu/index";
import Dropdown from "component/atoms/Dropdown";
import SVGIcons from "assets/icon";
import Constants from "constants/index";

const SYNC_STATES = {
  SYNC_DISABLE: 0,
  SYNC_AUTO: 1,
  SYNC_MANUAL: 2,
};

/**
 * @description Contrast 버튼 클릭시 나타나는 확장 메뉴. UI Component Container
 * @function ContrastDropdownMenu
 */
@inject("synchronizationStore")
@inject("toolbarStore")
@observer
class SynchronizationDropdownMenu extends React.PureComponent {
  handleToggleSyncManualAndAuto = (event) => {
    event.preventDefault();
    const { synchronizationStore } = this.props;

    if (synchronizationStore.isSupportedSynchronizationOnActive() === true) {
      synchronizationStore.toggleSyncState();
    } else {
      synchronizationStore.disableSyncState();
    }
  };
  handleToogleSyncSlicePositionActive = (event) => {
    event.preventDefault();
    const { synchronizationStore } = this.props;
    synchronizationStore.toggleSyncSlicePositionActive();
  };

  handleToogleSyncZoomAndPanActive = (event) => {
    event.preventDefault();
    const { synchronizationStore } = this.props;
    synchronizationStore.toggleSyncZoomAndPanActive();
  };

  handleToogleSyncWindowActive = (event) => {
    event.preventDefault();
    const { synchronizationStore } = this.props;
    synchronizationStore.toggleSyncWindow();
  };

  render() {
    const { synchronizationStore, toolbarStore } = this.props;
    let isSyncSlicePositionActive = synchronizationStore.isSyncSlicePositionActive();
    let isSyncActive = synchronizationStore.isSyncActive();
    // XXX : SplitSeries 기능 동작중, Slice 동기화 기능은 차단
    // 성능 문제로 이해 차단
    if (toolbarStore.isBatchViewMode() === true) {
      isSyncSlicePositionActive = false;
    }

    const isSyncZoomAndPanActive = synchronizationStore.isSyncZoomAndPanActive();
    const isSyncWindowActive = synchronizationStore.isSyncWindowActive();

    const syncState = synchronizationStore.getSyncState();
    const syncStateString = Constants.Synchronization.getSyncStateText(
      syncState
    );

    return (
      <React.Fragment>
        <Dropdown.Menu bsPrefix="dropdown-menu--toolbar">
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="1"
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onClick={this.handleToggleSyncManualAndAuto}
            active={isSyncActive}
            as="div"
          >
            {`Toggle Synchroization ${syncStateString}`}
          </Dropdown.Item>
          <Separator />
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="1"
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onClick={this.handleToogleSyncSlicePositionActive}
            active={isSyncSlicePositionActive}
            as="div"
          >
            {"Synchronize slice position"}
          </Dropdown.Item>
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="2"
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onClick={this.handleToogleSyncZoomAndPanActive}
            active={isSyncZoomAndPanActive}
            as="div"
          >
            {"Synchronize zoom & pan"}
          </Dropdown.Item>
          <Dropdown.Item
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey="3"
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onClick={this.handleToogleSyncWindowActive}
            active={isSyncWindowActive}
            as="div"
          >
            {"Synchronize window setting"}
          </Dropdown.Item>
        </Dropdown.Menu>
      </React.Fragment>
    );
  }
}

export default SynchronizationDropdownMenu;
